const defaultState = {
  data: [],
};

const Ads = (state = defaultState, action) => {
  switch (action.type) {
    case "ADD_NEW_AD":
      return { ...state, data: [...state.data, action.adData] };
    default:
      return state;
  }
};

export default Ads;



// WEBPACK FOOTER //
// ./src/reducers/Ads/index.js